import React, { Component } from "react";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { getAllCustomMapsCloseLoop } from "../../../components/UserFunctions";
import { connect } from "react-redux";
import Pagination from "./../../Pagination";
import { getCustomMapFromAPI } from "../../../actions/closeLoop/customMapActionCloseLoop";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import Breadcrumb from "react-bootstrap/Breadcrumb";

class CloseLoopViewCustomMap extends Component {
    constructor(props) {
        super(props);

        this.state = {
            custom_map_details: [],
        };
    }

    componentDidMount() {
        document.getElementsByClassName("print")[0].style.visibility = "hidden";
        document.getElementsByClassName("download")[0].style.visibility = "hidden";

        getAllCustomMapsCloseLoop().then((res) => {
            if (res.data) {
                this.props.dispatch(getCustomMapFromAPI(res));
                this.setState({
                    custom_map_details: res.data,
                });
            } else {
                this.props.dispatch(getCustomMapFromAPI({ data: [], current_page: 0, pages: [] }));
            }
        });
    }

    render() {
        const customStyles = {
            rows: {
                style: {
                    minHeight: "72px",
                    backgroundColor: "#C7C9FF",
                },
            },
            headCells: {
                style: {
                    fontSize: "1rem",
                    backgroundColor: "white",
                    padding: ".75rem",
                    verticalAlign: "top",
                    borderTop: "1px solid #e9ecef",
                    borderBottom: "5px solid #753DFF",
                    justifyContent: "center",
                },
            },
            cells: {
                style: {
                    fontSize: "1rem",
                    textAlign: "center",
                    verticalAlign: "top",
                    borderTop: "5px solid white",
                    justifyContent: "center",
                },
            },
        };

        const columns = [
            {
                name: "Map ID",
                selector: "custom_map_uuid",
                sortable: true,
                cell: (row) => <div style={{ flexWrap: "wrap" }}>{row.custom_map_uuid}</div>,
            },
            {
                name: "Map Name",
                selector: "name",
                sortable: true,
                cell: (row) => <div style={{ alignContent: "center" }}>{row.name}</div>,
            },
            {
                name: "UUID",
                selector: "custom_map_uuid",
                sortable: true,
                cell: (row) => <div style={{ alignContent: "center" }}>{row.custom_map_uuid}</div>,
            },
            {
                name: "Updated At",
                selector: "updated_at",
                sortable: true,
                cell: (row) => <div style={{ alignContent: "center" }}>{row.updated_at}</div>,
            },
        ];
        const data = this.props.customMapData;
        const tableData = {
            columns,
            data,
        };
        console.log("MAP", this.props.customMapData);
        console.log("dataaa", this.props.pages);

        return (
            <div data-test="mapViewComponent" className="container-fluid">
                <div className="row">
                    <div className="col mt-5 mx-auto">
                        <div className="card" style={{ backgroundColor: "white" }}>
                            <div className="card">
                                <h1
                                    className="card-header"
                                    style={{
                                        color: "white",
                                        fontSize: "100% !important",
                                        backgroundColor: "#757AF7",
                                    }}
                                >
                                    Custom Map Viewer
                                </h1>
                            </div>
                            <div className="card-body">
                                <DataTableExtensions {...tableData}>
                                    <DataTable
                                        className="dataTables_wrapper"
                                        columns={columns}
                                        customStyles={customStyles}
                                        data={data}
                                        defaultSortField="id"
                                        defaultSortAsc={false}
                                        //  pagination
                                        setFilter
                                    ></DataTable>
                                </DataTableExtensions>
                            </div>
                        </div>
                        <div>
                            {this.props.customMapData.length > 0 ? (
                                <Pagination
                                    currentPage={this.props.currentPage}
                                    pages={this.props.pages}
                                    getApiInfo={getAllCustomMapsCloseLoop}
                                    action={getCustomMapFromAPI}
                                />
                            ) : undefined}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

CloseLoopViewCustomMap.propTypes = {
    dispatch: PropTypes.func,
    customMapData: PropTypes.array,
    pages: PropTypes.array,
    currentPage: PropTypes.number,
};

const mapStateToProps = (state) => {
    return {
        customMapData: state.customMapCloseLoop.customMapData,
        currentPage: state.customMapCloseLoop.currentPage,
        pages: state.customMapCloseLoop.pages,
    };
};

export default connect(mapStateToProps)(CloseLoopViewCustomMap);
